module.exports = __webpack_public_path__ + "img/4.e1b7530f.jpg";